import { Close } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';

export const CloseButton = (props: IconButtonProps) => (
  <IconButton aria-label="close" {...props}>
    <Close />
  </IconButton>
);
